import {
  Typography,
  FormControl,
  Container,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

import { useNavigate, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  where,
  addDoc,
  serverTimestamp,
  doc,
} from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import { db } from "../firebase.config";
import { toast } from "react-toastify";

import CreateTierListContainer from "../components/CreateTierListContainer";

import React from "react";
import { useState, useEffect, useRef } from "react";
import Spinner from "../components/Spinner.jsx";

/* URL : /tierlist/new */
function CreateNewTierList(props) {
  const { appState, setAppState, genres, setGenres } = props;
  const [topics, setTopics] = useState(null);
  const [topicsMap, setTopicsMap] = useState(null);
  const [loading, setLoading] = useState(false);

  const auth = getAuth();
  const navigate = useNavigate();
  const isMounted = useRef(true);

  useEffect(() => {
    if (isMounted) {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          setAppState({ ...appState, userRef: user.uid });
        } else {
          navigate("/");
        }
      });
    }

    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted]);

  useEffect(() => {
    const fetchGenres = async () => {
      try {
        setLoading(true);
        // Get Genres
        // Get Reference
        const genreRef = collection(db, "formGenres");

        // Create a query
        const q = query(genreRef);

        // Execute query
        const querySnap = await getDocs(q);

        let newGenres = {};

        querySnap.forEach((doc) => {
          const docData = doc.data();
          const itemObject = {
            [doc.id]: {
              name: docData.name,
              key: docData.key,
              topicsRef: docData.topicsRef,
            },
          };
          newGenres = { ...newGenres, ...itemObject };
          return;
        });
        setGenres(newGenres);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Could not fetch Genres");
      }
    };
    fetchGenres();
  }, [setGenres]);

  const fetchItems = async () => {
    if (appState.tierListGenre.name !== "DEFAULT") {
      try {
        // Get items
        // Get Reference
        const itemsRef = collection(db, "formItems");

        const tierListItemsRef = appState.tierListTopic;

        // Create a query
        const q = query(itemsRef, where("__name__", "==", tierListItemsRef));

        // Execute query
        const querySnap = await getDocs(q);

        let newItems = [];

        querySnap.docs[0].data().items.forEach((item) => {
          const itemObject = {
            desc: item.desc,
            imageUrl: item.imageUrl,
          };
          newItems = [...newItems, itemObject];
        });

        return newItems;
      } catch (error) {
        toast.error("Could not fetch Items");
      }
    }
  };

  useEffect(() => {
    const fetchTopics = async () => {
      if (appState.tierListGenre.name !== "DEFAULT") {
        try {
          // Get topics
          // Get Reference
          const topicsRef = collection(db, "formTopics");

          const tierListTopicRef = genres[appState.tierListGenre.id].topicsRef;

          // Create a query
          const q = query(topicsRef, where("__name__", "==", tierListTopicRef));

          // Execute query
          const querySnap = await getDocs(q);

          let newTopics = {};

          querySnap.forEach((doc) => {
            const docData = doc.data();
            const itemObject = {
              name: docData.name,
              options: docData.options,
            };

            /* Create topic map */
            let newItemMap = {};
            itemObject.options.forEach((option) => {
              const topicObject = {
                [option.itemsRef.id]: {
                  name: option.name,
                  key: option.key,
                },
              };
              newItemMap = { ...newItemMap, ...topicObject };
            });
            setTopicsMap(newItemMap);
            newTopics = itemObject;
            return;
          });
          setTopics(newTopics);
        } catch (error) {
          toast.error("Could not fetch Topics!");
        }
      }
    };
    // Gotta fetch topics
    fetchTopics();
  }, [appState.tierListGenre, genres]);

  const onChange = (e) => {
    if (e.target.name === "tierListGenre") {
      setAppState((prevState) => ({
        ...prevState,
        tierListGenre: {
          id: e.target.value,
          name: genres[e.target.value].name,
          // name: appState.genres[e.target.value].name,
        },
        tierListTopic: "DEFAULT",
      }));
    } else {
      setAppState((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const buildItems = (formItems) => {
    let itemObjects = {};
    let newItemIdArray = [];
    let newItemCount = 0;
    if (formItems) {
      formItems.forEach((formItem, index) => {
        let itemName = "item-" + index;
        newItemIdArray.push(itemName);
        let itemObject = {
          [itemName]: {
            id: itemName,
            imageUrl: formItem.imageUrl,
            altText: formItem.desc,
            content: "test-" + index,
          },
        };
        itemObjects = { ...itemObjects, ...itemObject };
        newItemCount++;
      });
      let draftRow = appState.newDraft.rows["row-draft"];
      let newRows = appState.newDraft.rows;
      // let draftCount = 0;
      // if (appState.drafts && Object.keys(appState.drafts).length > 0) {
      //   draftCount = Object.keys(appState.drafts).length;
      // }
      newRows[draftRow.id] = { ...draftRow, itemIds: newItemIdArray };
      const genreRef = doc(db, "formGenres", appState.tierListGenre.id);
      const authorRef = doc(db, "users", appState.userRef);
      setAppState((prevState) => ({
        ...prevState,
        newDraft: {
          itemCount: newItemCount,
          rows: newRows,
          draft: true,
          genreRef: genreRef,
          items: itemObjects,
          author: authorRef,
          rowOrder: appState.rowOrder,
          title: appState.tierListTopic,
          userRef: auth.currentUser.uid,
        },
        // drafts: {
        //   ...prevState.drafts,
        //   ["draft-" + draftCount]: {
        //     itemCount: newItemCount,
        //     rows: newRows,
        //     draft: true,
        //     genreRef: appState.tierListGenre,
        //     items: itemObjects,
        //     author: prevState.userRef,
        //     rowOrder: newRows,
        //     title: appState.tierListTopic,
        //   },
        // },
        itemCount: newItemCount,
        rows: newRows,
        items: itemObjects,
      }));
      return itemObjects;
    }
  };

  const clearTierList = () => {
    const newRows = appState.newDraft.rows;
    for (let row in newRows) {
      newRows[row].itemIds = [];
    }
    setAppState((prevState) => ({
      ...prevState,
      newDraft: { ...prevState.newDraft, rows: newRows },
    }));
  };

  const toggleTemplateControls = () => {
    setAppState((prevState) => ({
      ...prevState,
      showTemplateControls: !appState.showTemplateControls,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    // changeTierListTopic();
    const newItems = await fetchItems();
    clearTierList();
    buildItems(newItems);
    toggleTemplateControls();
  };

  const saveDraft = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Save draft function ran");
    const genreRef = doc(db, "formGenres", appState.tierListGenre.id);
    const tierListCopy = {
      ...appState.newDraft,
      titleName: topicsMap[appState.tierListTopic].name,
      titleKey: topicsMap[appState.tierListTopic].key,
      draft: true,
      genreRef,
      genreName: appState.tierListGenre.name,
      timestamp: serverTimestamp(),
    };
    console.log("tierListCopy :", tierListCopy);

    const docRef = await addDoc(collection(db, "tierLists"), tierListCopy);
    setLoading(false);
    toast.success("Listing saved");
    navigate(`/tierlist/${docRef.id}`);
  };

  const publishDraft = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Save draft function ran");
    const genreRef = doc(db, "formGenres", appState.tierListGenre.id);
    const tierListCopy = {
      ...appState.newDraft,
      titleName: topicsMap[appState.tierListTopic].name,
      draft: false,
      titleKey: topicsMap[appState.tierListTopic].key,
      genreRef,
      genreName: appState.tierListGenre.name,
      timestamp: serverTimestamp(),
    };
    console.log("tierListCopy :", tierListCopy);

    const docRef = await addDoc(collection(db, "tierLists"), tierListCopy);
    setLoading(false);
    toast.success("Listing saved");
    navigate(`/tierlist/${docRef.id}`);
  };

  return (
    <>
      <Container>
        <Typography variant="h3" component="h1">
          Create a new Tier List
        </Typography>
        {loading ? (
          <Spinner />
        ) : (
          <>
            {appState.showTemplateControls && (
              <form
                onSubmit={onSubmit}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* <FormControl
              sx={{
                display: "flex",
                flexDirection: "row",
                margin: "10px 0",
              }}
            >
              <Typography
                variant="h5"
                component="h2"
                sx={{ alignSelf: "center" }}
              >
                <label htmlFor="tier-list-title">Title: </label>
              </Typography>
              <input
                name="tierListTitle"
                onChange={onChange}
                value={appState.tierListTitle}
                id="tierListTitle"
                aria-describedby="tierListTitle"
                style={{ fontSize: "50px" }}
              />
            </FormControl> */}
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    margin: "10px 0",
                    alignItems: "center",
                  }}
                >
                  <label htmlFor="tierListGenre">Choose a Genre</label>
                  <Select
                    labelId="tierListGenre"
                    id="tierListGenre"
                    name="tierListGenre"
                    value={appState.tierListGenre.id}
                    label="tierListGenre"
                    onChange={onChange}
                  >
                    {appState.tierListGenre?.name === "DEFAULT" && (
                      <MenuItem value="DEFAULT" disabled>
                        Genres...
                      </MenuItem>
                    )}
                    {Object.keys(genres).map((genreId) => (
                      // genreKey or genreId?
                      <MenuItem key={genres[genreId].key} value={genreId}>
                        {genres[genreId].name}
                      </MenuItem>
                    ))}
                  </Select>
                  <span>
                    Don't see a genre you want?{" "}
                    <Link to="/genre/create"> Create a new Genre</Link>
                  </span>
                </FormControl>

                {appState.tierListGenre.name !== "DEFAULT" && (
                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      margin: "10px 0",
                      alignItems: "center",
                    }}
                  >
                    <label htmlFor="tierListTopic">Choose a Topic</label>
                    <Select
                      labelId="tierListTopic"
                      id="tierListTopic"
                      name="tierListTopic"
                      value={appState.tierListTopic}
                      label="tierListTopic"
                      onChange={onChange}
                    >
                      {appState.tierListTopic === "DEFAULT" && (
                        <MenuItem value="DEFAULT" disabled>
                          Topics...
                        </MenuItem>
                      )}

                      {topics !== null &&
                        topics.options[0] !== "" &&
                        topics.options.map((topic) => (
                          <MenuItem key={topic.name} value={topic.itemsRef.id}>
                            {topic.name}
                          </MenuItem>
                        ))}
                    </Select>
                    <span>
                      Don't see a topic you want?{" "}
                      <Link to="/topic/create"> Create a new topic</Link>
                    </span>
                  </FormControl>
                )}
                {appState.tierListTopic !== "DEFAULT" && (
                  <>
                    <FormControl
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        margin: "10px 0",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{ textTransform: "none" }}
                        fullWidth
                        color="success"
                      >
                        Insert Template
                      </Button>
                    </FormControl>
                    <FormControl>
                      <Button
                        onClick={toggleTemplateControls}
                        variant="contained"
                        fullWidth
                        sx={{
                          textTransform: "none",
                          margin: "10px 0",
                          display: "block",
                        }}
                        color="error"
                      >
                        Hide Template Controls
                      </Button>
                    </FormControl>
                  </>
                )}
              </form>
            )}
            {appState.showTemplateControls === false && (
              <Button
                onClick={toggleTemplateControls}
                variant="contained"
                fullWidth
                color="success"
                sx={{ textTransform: "none", margin: "10px 0" }}
              >
                Show Template Controls
              </Button>
            )}
            {appState.tierListTopic !== "DEFAULT" && topicsMap && (
              <Typography variant="h2" component="h2">
                {topicsMap[appState.tierListTopic]?.name}
              </Typography>
            )}
            <CreateTierListContainer
              appState={appState}
              setAppState={setAppState}
            />
            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
              <FormControl sx={{ marginBottom: "50px" }}>
                <form onSubmit={saveDraft}>
                  <Button variant="contained" color="secondary" type="submit">
                    Save as Draft
                  </Button>
                </form>
              </FormControl>
              <FormControl>
                <form onSubmit={publishDraft}>
                  <Button variant="contained" color="success" type="submit">
                    Publish
                  </Button>
                </form>
              </FormControl>
            </div>
          </>
        )}
      </Container>
    </>
  );
}

export default CreateNewTierList;
